import { render, staticRenderFns } from "./CreateOrganizationPage.vue?vue&type=template&id=0471c819&scoped=true"
import script from "./CreateOrganizationPage.vue?vue&type=script&lang=ts"
export * from "./CreateOrganizationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0471c819",
  null
  
)

export default component.exports